// Data tables page.
//
// Standalone home for full row-level table downloads, split out of the export
// builder. Thin wrapper around LargeTablesPanel (which owns the per-table,
// per-format download logic and logs each pull to the export history).
import React, { useState } from 'react';
import { Box, Typography, Snackbar } from '@mui/material';
import LargeTablesPanel from './LargeTablesPanel';

export default function DataTablesPage({ scope }) {
    const [toast, setToast] = useState('');
    return (
        <Box sx={{ p: '6px 24px 48px', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ mb: 0.5 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: 'text.primary' }}>Data tables</Typography>
                <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.25 }}>
                    Download a full dataset on its own, in any format. Every pull is recorded in your export history.
                </Typography>
            </Box>
            <LargeTablesPanel onToast={setToast} scope={scope} />
            <Snackbar open={!!toast} autoHideDuration={3500} onClose={() => setToast('')} message={toast} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </Box>
    );
}
